import { defaultFileInput } from 'src/helpers'

export const soFormInitialValue = {
  customer: null,
  soNoCustomer: null,
  poFileCustomer: defaultFileInput(),
  isUpo: false,
  referalCode: null,
  paymentMethod: null,
  address: null,
  isPpn: true,
  products: [],
  shippingCosts: []
}
